module.exports = __webpack_public_path__ + "assets/extjs.6cbe54ba.svg";